import React, {ReactNode} from 'react';
import {View, ViewStyle} from 'react-native';

import {styles} from './Spacing.style';

interface SpacingProps {
  direction: 'inner' | 'outer';
  size: number;
  style: ViewStyle;
  children: ReactNode;
}

export const Spacing: React.FC<SpacingProps> = ({
  direction = 'outer',
  size = 0,
  style = {},
  children = null,
}) => {
  const spacingStyle: ViewStyle =
    direction === 'inner' ? {padding: size} : {margin: size};

  return <View style={[styles.base, spacingStyle, style]}>{children}</View>;
};

export default Spacing;
